<template>
  <div class="root row hcenter">
    <div class="card m-auto text-white">
      <div class="card-content">
        <template v-if="apiStatus === 3">
          <status-info status="error" :message="emailMsg" :timeout="10000" />
        </template>
        <template v-else-if="apiStatus === 2">
          <status-info
            status="success"
            :message="
              `An email was sent to ${email} with instructions on how to proceed`
            "
            :timeout="20000"
          />
        </template>

        <form @submit.prevent="sendEmail">
          <!-- TODO find a way to use the value prop properly -->
          <input-field
            label="email"
            icon="email"
            type="email"
            focusClass="text-white"
            :focus="true"
            :error="emailErrors"
            @keyup="handleKeys"
          />

          <!-- <div class="input-field mb-1">
          <input type="checkbox" class="outline" id="remember-me" />
          <label for="remember-me">Remember Me</label>
          </div>-->
          <div class="mt-2">
            <button
              type="submit"
              class="block mb-2 waves"
              :class="apiStatus === 1 ? 'pulse' : null"
            >
              {{ apiStatus === 2 ? "Resend" : null }} Send Email
            </button>
          </div>
        </form>
        <div class="input-field mb-0">
          <router-link :to="{ name: 'Login' }">Back To Login</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import { mapGetters } from "vuex";

import InputField from "@/components/InputField";
import StatusInfo from "../../../components/StatusInfo.vue";

export default {
  name: "PasswordForgot",
  components: {
    InputField,
    StatusInfo,
  },
  computed: {
    ...mapGetters({
      apiStatus: "Auth/sendEmailStatus",
      emailMsg: "Auth/sendEmailMessage",
    }),
  },
  data() {
    return {
      email: "",
      emailErrors: "",
    };
  },
  beforeDestroy() {
    // reset
    this.$store.commit("Auth/sendEmailDefault");
  },
  mounted() {
    T.waves();
  },
  methods: {
    validate() {
      let success = false;
      if (this.email !== "") {
        this.emailErrors = "";
        success = true;
      } else this.emailErrors = `Please enter your email`;

      return success;
    },
    handleKeys(e) {
      if (e.key === "Tab" || e.key === "Shift") return;
      this.email = e.target.value.trim();

      this.validate();
    },

    sendEmail(e) {
      const form = e.target;
      const email = new FormData(form).get("email");
      this.email = email;

      if (!this.validate()) return;

      this.$store.dispatch("Auth/sendEmail", { email }).then(() => {
        if (this.sendEmailStatus === 2) {
          // TODO: display success message to the user
          console.log(this.sendEmailMessage);
          // this.$router.push({ name: "PasswordReset", params: { passwordResetToken: localStorage.getItem("passwordToken") } });
        } else if (this.sendEmailStatus === 3) {
          // TODO: display error message to the user
          console.log("Error:", this.sendEmailMessage);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.root .card {
  width: 100%;
  color: white;
  max-width: 330px;
  background-color: #000000da;

  @supports ((backdrop-filter: blur(20px))) {
    backdrop-filter: blur(20px);
    background-color: #000000a9;
    border: 2px solid #ffffff29;
  }
}
</style>
